<template>
    <div class="home-construction-section" v-if="pageSetup != null">
        <div class="container">
            <div class="const-section-title">
                <h2>{{ pageSetup.cons_section_title }}</h2>
                <!-- <router-link to="/activities">
                    <img src="https://bcn.kz/cms/media/all-cons.svg" alt="">
                    <span>{{ pageSetup.cons_btn_more }}</span>
                </router-link> -->
            </div>
            <div class="const-cards-carousel">
                <swiper :options="swiperOption" ref="promoCarousel">
                    <swiper-slide v-for="(slide, index) in pageSetup.cons_cards" :key="index">
                        <div class="promo-pic" :style="'background-image: url(' + slide.img + ')'">
                        </div>
                        <h3 v-html="slide.name"></h3>
                    </swiper-slide>
                </swiper>
                <div class="swiper-controls const-controls">
                    <div class="const-btn-prev slider-btn">
                        <svgIcon name="left-arrow" class="icon-left-arrow"/>
                    </div>
                    <div class="const-btn-next slider-btn">
                        <svgIcon name="right-arrow" class="icon-right-arrow"/>
                    </div>
                </div>
                <div class="swiper-pagination const-pagination"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'home-construction-section',
        components: {
            svgIcon,
        },
        data () {
            return {
                swiperOption: {
                    speed: 800,
                    observer: true,
                    observeParents: true,
                    effect: 'slide',
                    slidesPerView: 4,
                    spaceBetween: 20,
                    simulateTouch: true,
                    watchSlidesVisibility: true,
                    loop: true,
                    // lazy: {
                    //     loadPrevNext: true,
                    //     loadOnTransitionStart: true
                    // },
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: true,
                    },
                    navigation: {
                        nextEl: '.const-btn-next',
                        prevEl: '.const-btn-prev',
                    },
                    pagination: {
                        el: '.const-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                    breakpoints: {
                        // when window width is >= 900px
                        900: {
                            slidesPerView: 2,
                            spaceBetween: 15
                        },
                    }
                },
            }
        },
        computed: mapGetters({
            pageSetup: 'loadIndexPage',
        }),
        methods: {
            startLoader() {
                // this.$parent.$parent.$refs.topProgress.start();
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/home-page/home-construction.scss';
    @import '@/styles/components/home-page/respond/home-construction-respond.scss';
</style>